import ConfigManager from "@/config/ConfigManager";
import BzbsApi from "@/core/Http/BzbsApi";
//helper
import Locale from "@/helper/locale/Locale.js";
import AccountHelper from "@/helper/AccountHelper";
import { NotificationType } from "@/helper/StaticValue";
import { map } from 'rxjs/operators';
import { provide, ref } from "vue";


//#region model
export const NotificationModel = function (obj = null) {
    this.createTime = 0
    this.expireDate = 0
    this.img = null
    this.isRead = false
    this.campaignId = null
    this.categoryId = null
    this.type = NotificationType.Message
    this.partitionKey = null
    this.rowKey = null
    this.object = null
    this.message = ""
    this.isEarnReward = false

    if (obj != null) {
        this.setValues(obj)
    }
}

NotificationModel.prototype.setValues = function (obj) {
    this.lbl = Locale.getLbl();
    this.createTime = obj?.CreateTime ?? 0
    this.expireDate = obj?.ExpireDate ?? 0
    this.img = obj?.ImagePath ?? null
    this.isRead = obj?.IsRead ?? false
    this.campaignId = obj?.ObjectCampaignId ?? null
    this.categoryId = obj?.ObjectCategoryId ?? null
    this.type = obj?.ObjectType ?? NotificationType.Message
    this.partitionKey = obj?.PartitionKey ?? null
    this.rowKey = obj?.RowKey ?? null
    this.object = obj?.Object
    this.isEarnReward = obj?.Object?.description == "earn_reward" ? true : false

    if (this.type == NotificationType.Link) {
        this.message = obj?.Object?.message ?? ""
    } else if (this.type == NotificationType.Campaign) {
        this.message = obj?.Object?.Name
    } else if (this.type == NotificationType.Category) {
        this.message = obj?.Object?.Name
    } else if (this.type == NotificationType.Badge && obj?.Object?.description != "earn_reward") {
        // check fb_description before description , if fb_description is replace {point} with points
        this.message = obj?.Object?.fb_description ? obj?.Object?.fb_description.replace(/\{points\}/g, obj?.Object?.points) : obj?.Object?.description ?? ""
        // this.message = obj?.Object?.description ?? ""
  
    } else if (this.type == NotificationType.Badge && obj?.Object?.description == "earn_reward") {

        this.message = obj?.Object?.auto_redeem?.CampaignName +"! " + this.lbl.redeem_button.redeem_noti_btn
    }
    else {
        this.message = obj?.Object?.message ?? ""
    }
}

//#endregion model

export default function useNotificationStore() {
    const items = ref([])
    const count = ref(0)

    const methods = {
        getNotifications: function () {
            let url = ConfigManager.getApiUrl() + "/noti"
            let token = AccountHelper.getToken()
            let params = {
                top: 500,
                device_app_id: ConfigManager.getAppId(),
                sortby: "createdate_desc"
            }
            BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
                let arr = []
                for (const item of res.data) {
                    arr.push(new NotificationModel(item))
                }
                return arr;
            })).subscribe({
                next: (data) => {
                    items.value = data
                    count.value = items.value.filter(x => !x.isRead).length
                },
                error: () => {
                    items.value = []
                }
            })
        },
        clear: function () {
            items.value = []
            count.value = 0
        },
        /**
         *
         * @param {string} rowKey - row key of notification item
         */
        sendRead: function (rowKey) {
            // call api read
            let url = ConfigManager.getApiUrl() + "/noti/read?ids=" + rowKey
            let token = AccountHelper.getToken()

            return BzbsApi.connectBzbsPost(url, token, {}).pipe(map((res) => {
                return res.data
            }))
        },
        readAll: function () {
            // call api read All
            let url = ConfigManager.getApiUrl() + "/noti/read_all"
            let token = AccountHelper.getToken()

            return BzbsApi.connectBzbsPost(url, token, {}).pipe(map((res) => {
                return res.data
            }))
        },

    }

    provide("NotificationStore", {
        count,
        items,
        methods
    })

    return {
        items,
        count,
        methods
    }
}
